import { render, staticRenderFns } from "./UnauthorizedSidebar.vue?vue&type=template&id=12ceab59"
import script from "./UnauthorizedSidebar.vue?vue&type=script&lang=js"
export * from "./UnauthorizedSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports